<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import wait from 'waait'

import api from '@/api'
import {Dict} from '@/typings/custom'

class MotionDataManager {
  /**
   * Abstracts calling the API in bulk so we are not making 50 api requests per page load.
   */
  data: Dict<any> = {}
  promise: Promise<any> = null

  async getMotions(spaceId: string): Promise<any> {
    if (this.data[spaceId]) {
      return this.data[spaceId]
    } else {
      this.data[spaceId] = null
    }

    await wait(1000)
    await this.fetchData()
    return this.data[spaceId]
  }

  async fetchData() {
    if (this.promise) return await this.promise

    let spaceIds = Object.keys(this.data)
    this.promise = api.spaces.activity(spaceIds)
    let response = await this.promise

    response.data.map((obj) => {
      this.data[obj.spaceId] = obj.events
    })

    this.promise = null
  }
}

// Singleton
const motionMgr = new MotionDataManager()

@Component({})
export default class MotionLocation extends Vue {
  @Prop()
  spaceId: string

  @Prop({default: 1})
  limit: number

  loading = true
  events: any[] = null

  async mounted() {
    this.events = await motionMgr.getMotions(this.spaceId)
    this.loading = false
  }
}
</script>

<template>
  <div>
    <div v-if="events" class="row">
      <template v-for="event in events.slice(0, limit)">
        <div class="col">
          <b>{{ event.location_label | title }}</b>
        </div>

        <!-- Considered recent if less than 24 hours ago -->
        <div v-if="$dayjs().unix() - event.timestamp < 86400" class="col">
          {{ $dayjs(event.timestamp * 1000).fromNow() }}
        </div>
        <div v-else class="text-black-50 col">
          {{ $dayjs.tz(event.timestamp * 1000).format('L h:mm a') }}
        </div>
      </template>
    </div>
    <div v-else-if="loading" class="text-center">
      <div class="spinner-border" role="status"></div>
    </div>
    <div v-else></div>
  </div>
</template>
